import React from 'react';
import PropTypes from 'prop-types';

import ClassificationSelector from 'components/MenuManagement/Fields/ClassificationSelector';

export default function ClassificationsSelectorField({ form, title, dataIndex, record }) {
  return (
    <ClassificationSelector
      selectedOptions={form.values[dataIndex] || []}
      setSelectedOptions={options => form.setFieldValue(dataIndex, options)}
      recordUuid={record?.uuid}
      title={title}
      error={form.errors[dataIndex]}
    />
  );
}

ClassificationsSelectorField.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  record: PropTypes.object,
  title: PropTypes.string,
  dataIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
